const toNumberField = {
  name: "toNumber",
  label: "To Number",
  description: "Please pre-fix country code to the number",
  type: "text",
};

const triggerTypeField = {
  name: "triggerType",
  label: "Trigger type",
  type: "select",
  options: [
    {
      id: 0,
      value: "",
      label: "No selection",
    },
    {
      id: 1,
      value: "triggerImmediately",
      label: "Trigger Immediately",
    },
    {
      id: 2,
      value: "triggerBasedOnCampaign",
      label: "Trigger Based on Business Hours & Follow Ups",
    },
  ],
};

export { toNumberField, triggerTypeField };
